import Tooltip from '~/components/tooltip'

import styles from './styles.module.css'

const Facet = ({
  inputName,
  inputValue,
  inputId,
  inputDisabled,
  inputChecked,
  inputOnChange,
  labelName,
  labelUnit,
  labelCount,
  tooltipText,
  isLastChild = false
}) => (
  <div className={styles.container} data-is-last={isLastChild}>
    <label className={styles.facet} data-disabled={inputDisabled}>
      <input
        type='checkbox'
        name={inputName}
        value={inputValue}
        id={inputId}
        disabled={inputDisabled}
        defaultChecked={inputChecked}
        onClick={(event) => inputOnChange(event)}
      />
      <span className={styles.checkmark} data-is-checked={inputChecked}></span>
      <div className={styles.labelContainer}>
        <div className={styles.name}>
          <span>{labelName}</span> <span>{labelUnit}</span>
          <span className={styles.count}>({labelCount})</span>
        </div>
      </div>
    </label>
    <If condition={!!tooltipText}>
      <Tooltip content={tooltipText} wrapperStyles={styles.tooltipWrapper} />
    </If>
  </div>
)

export default Facet
